module.exports = __webpack_public_path__ + "static/media/leicester-night.07a39410.jpg";